
export default class CovidPatient {
    id=""
    identification=""
    name=""
    lastName=""
    status=""
    company=""
    agency=""
    userDoctor=""
    userAsistant=""
}


// WEBPACK FOOTER //
// ./src/model/CovidPatient.js